import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Toast from "./plugins/toast";
import axios from "axios";
import VueAxios from "vue-axios";
import $ from "jquery";
import VueHead from "vue-head";
import VueMeta from "vue-meta";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueObserveVisibility from "vue-observe-visibility";
import VueGridLayout from "vue-grid-layout";
import VueGtag from "vue-gtag";
import "animate.css";
import vuesax from "./plugins/vuesax";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import PrimeVue from "primevue/config";
import "boxicons";

Vue.use(PrimeVue);
Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);

Vue.use(VueGtag, {
  config: { id: "G-6L9J5LDM79" },
});

Vue.use(VueHead);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});
Vue.use(VueSweetalert2);
Vue.use(VueObserveVisibility);
Vue.use(VueAxios, axios);
// Vue.prototype.$axios = axios
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  vuesax,
  Toast,
  render: (h) => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount("#app");
// mounted() {
//   Pace.start();
//   Pace.on("hide", () => {
//     document.dispatchEvent(new Event("app.rendered"));
//   });
// },
